<div class="btn-group">
    <button class="btn btn-default mat-stroked-button dropdown-toggle exportBtn" type="button" id="exportBtn" data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false" #exportBtn=async-btn async-btn [loadingLabel]="'Exportando'"> Exportar <span class="caret"></span>
    </button>
    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="exportBtn">
        <div *ngIf="!hideXlsButton">
            <button type="button" class="dropdown-item exportXlsBtn" (click)="xlsClicked($event)"><i class="fa fa-file-excel-o" aria-hidden="true"></i>
                Excel
            </button>
        </div>
        <button type="button" class="dropdown-item exportCsvBtn" (click)="csvClicked($event)"><i class="fa fa-file-excel-o" aria-hidden="true"></i> Csv
        </button>
    </ul>
</div>
